module.exports = __webpack_public_path__ + "img/Group 97964.92efe068.png";